import { SEARCH_FORM_ID_USER } from "components/constent";
import TableRow from "components/rows/tableRow";
import Select from "components/select";
import PhoneSelect from "components/select/phone/phone";
import Cell from "components/rows/cell";
import { useTranslation } from "react-i18next";
import { useUserFilterContext } from "./context";
import { regNum } from "components/utils/comm";
import { useSubmit } from "./handles";

export default function SearchForm() {
  const { t } = useTranslation();
  const { filters, onChange, onSelect, onReset } = useUserFilterContext();
  const { onSubmit } = useSubmit();

  return (
    <>
      <form id={SEARCH_FORM_ID_USER} onSubmit={onSubmit} onReset={onReset}>
        <table>
          <tbody>
            <TableRow title={"회원정보"}>
              <ul>
                <li>
                  <Cell
                    label={t("lbl_mem_no_cmm")}
                    name={"memNo"}
                    value={filters?.memNo}
                    dataTyp="C"
                    onChange={(e) => onChange("memNo", e.currentTarget.value)}
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_eml_id_cmm")}
                    name="emlId"
                    value={filters?.emlId}
                    dataTyp="C"
                    onChange={(e) => onChange("emlId", e.currentTarget.value)}
                  />
                </li>
                <li>
                  <label htmlFor="">국가번호</label>
                  <PhoneSelect
                    styles="flex-1 h-full bg-white border-gray-400"
                    ulStyles="top-[26px]"
                    isReset={filters.mobCntyCd === "+82"}
                    onSelect={(phone) => onSelect("mobCntyCd", phone)}
                  />
                </li>
                <li>
                  <label htmlFor="">{t("lbl_phone_cmm")}</label>
                  <input
                    type="text"
                    name="mobNo"
                    value={filters?.mobNo}
                    data-type="C"
                    placeholder="숫자만 입력"
                    onChange={(e) => {
                      const value = e.currentTarget.value;
                      if (!regNum.test(value)) return;
                      if (regNum.test(value)) {
                        onChange("mobNo", value);
                      }
                    }}
                  />
                </li>
                <li>
                  <label htmlFor="">상태</label>
                  <Select
                    styles="bg-white border-1"
                    name={"uYn"}
                    isReset={!filters?.uYn}
                    options={uYns}
                    isInitialData
                    onSelect={(option) => {
                      onSelect("uYn", option.code);
                    }}
                  />
                </li>
              </ul>
            </TableRow>
          </tbody>
        </table>
      </form>
    </>
  );
}

const uYns = [
  // {
  //   ko: "승인",
  //   en: "approval",
  //   value: "",
  //   code: "",
  // },
  {
    ko: "탈퇴",
    en: "withdrawn",
    value: "soYn",
    code: "soYn",
  },
  {
    ko: "휴먼",
    en: "dormant",
    value: "lckYn",
    code: "lckYn",
  },
];
